export const STATION_DETAILS = 'STATION_DETAILS';
export const STATION_IMAGES = 'STATION_IMAGES';
export const CONTACT_FORM = 'CONTACT_FORM';
export const PROMOTION_DATA = "PROMOTION_DATA";